import {CommonModule} from "@angular/common";
import {NgModule} from "@angular/core";
import {
    MatInputModule, MatButtonModule, MatSelectModule, MatMenuModule, MatTableModule,
    MatPaginatorModule, MatSortModule, MatDialogModule, MatDatepickerModule, NativeDateAdapter,
    MatProgressSpinnerModule, MatSlideToggleModule, MatSnackBarModule, MatIconModule, MatCheckboxModule,
    MatPaginatorIntl, MatRadioModule
} from '@angular/material';
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {AppRoutingModule} from "../../app-routing.module";
import {CheckitDashboardComponent} from "./checkit-dashboard.component";
import {EventDashboardComponent} from './components/event-dashboard.component';
import {EventsDashboardComponent} from "./components/events-dashboard.component";
import {
    NewEventDialog, PopulateNewEventDialog, RegistrantDialogComponent, DeleteRegistantDialog,
    DeleteEventDialog, EmailEditDialogComponent, PreviewDialogComponent, CustomUidsDialog, OverLimitDialogComponent,
    CheckinInformationDialogComponent, CloseEventDialog, ProgressMessageDialogComponent, SendTestDialogComponent, RecipientsDialogComponent
} from './components/dialogs';
import {PaymentService} from "../../payment/payment.service";
import {IconedSnackBar} from "./components/snackbars";
import {SpreadsheetComponent} from "./components/spreadsheet.component";
import {SharedModule} from "app/shared/shared.module";
import { TimeInputComponent } from "app/shared/time-input/time-input.component";
import { SeatComponent } from './components/seat';
import { HttpClientModule } from '@angular/common/http';
import { QRCodeModule } from 'angular2-qrcode';
import { TimePipe } from "app/shared/time.pipe";

/**
 * Created by greg on 27/02/2018.
 */

@NgModule({
    imports: [
        CommonModule,
        AppRoutingModule,
        MatInputModule,
        MatSelectModule,
        MatButtonModule,
        MatMenuModule,
        MatTableModule,
        MatPaginatorModule,
        MatSortModule,
        MatDialogModule,
        MatButtonModule,
        MatDatepickerModule,
        MatProgressSpinnerModule,
        MatSlideToggleModule,
        MatSnackBarModule,
        MatIconModule,
        MatCheckboxModule,
        MatRadioModule,
        FormsModule,
        ReactiveFormsModule,
        SharedModule,
        HttpClientModule,
        QRCodeModule
    ],
    declarations: [CheckitDashboardComponent, EventsDashboardComponent, EventDashboardComponent, NewEventDialog, PopulateNewEventDialog,
        RegistrantDialogComponent, DeleteRegistantDialog, DeleteEventDialog, CloseEventDialog, CustomUidsDialog, EmailEditDialogComponent,
        PreviewDialogComponent, IconedSnackBar, SpreadsheetComponent, SeatComponent, OverLimitDialogComponent, CheckinInformationDialogComponent,
        ProgressMessageDialogComponent, SendTestDialogComponent, RecipientsDialogComponent],
    providers:[PaymentService, NativeDateAdapter, MatPaginatorIntl, TimePipe],
    entryComponents:[NewEventDialog, PopulateNewEventDialog, RegistrantDialogComponent, DeleteRegistantDialog, DeleteEventDialog,
        CloseEventDialog, EmailEditDialogComponent, PreviewDialogComponent, CustomUidsDialog, IconedSnackBar, TimeInputComponent, SeatComponent,
        OverLimitDialogComponent, CheckinInformationDialogComponent, ProgressMessageDialogComponent, SendTestDialogComponent,
        RecipientsDialogComponent]
})
export class CheckitDashboardModule { }


// WEBPACK FOOTER //
// ./src/app/pages/checkit-dashboard/checkit-dashboard.module.ts